import { STATUS } from 'src/constants/common';

export const CP_STATUS_OPTION = [
    {
        label: 'Requested',
        value: STATUS.OPENED,
    },
    {
        label: 'Quoted',
        value: STATUS.ACTIVE,
    },
    {
        label: 'Booked',
        value: STATUS.BOOKED,
    },
];

export const CP_CLASSIFICATION_OPTIONS = [
    {
        label: 'LTL',
        value: 'ltl',
    },
    {
        label: 'FTL',
        value: 'ftl',
    },
];

export const MAX_VIEW_COUNT = 8;

export const DEFAULT_TAB_VALUES = ['All', STATUS.OPENED, STATUS.ACTIVE, STATUS.BOOKED];

export const SORTABLE_INITIAL_STATE = {
    isOpen: false,
    data: [],
};

export const BULK_SELECTION_INITIAL_STATE = {
    isOpen: false,
    data: [] as number[],
};

export const CP_QUOTE_TABLE_ALIAS = 'cp_quotes';

export const CP_QUOTE_DEFAULT_COLUMNS = [
    {
        id: 'code',
        name: 'Quote',
        visible: true,
        displayOrder: 1,
    },
    {
        id: 'status',
        name: 'Status',
        visible: true,
        displayOrder: 2,
    },
    {
        id: 'classification',
        name: 'Service Type',
        visible: true,
        displayOrder: 3,
    },
    {
        id: 'userData',
        name: 'Created By',
        visible: true,
        displayOrder: 4,
    },
    {
        id: 'division',
        name: 'Division',
        visible: true,
        displayOrder: 5,
    },
    {
        id: 'customerBillingAccount',
        name: 'Billing Account',
        visible: true,
        displayOrder: 6,
    },
    {
        id: 'shipperFullAddress',
        name: 'From',
        visible: true,
        displayOrder: 7,
    },
    {
        id: 'consigneeFullAddress',
        name: 'To',
        visible: true,
        displayOrder: 8,
    },
    {
        id: 'stopsCount',
        name: 'Quote Type',
        visible: true,
        displayOrder: 9,
    },
    {
        id: 'updatedAt',
        name: 'Last Modified',
        visible: true,
        displayOrder: 10,
    },
    {
        id: 'createdAt',
        name: 'Creation Date',
        visible: true,
        displayOrder: 11,
    },
    {
        id: 'pickupDate',
        name: 'Pickup Date',
        visible: true,
        displayOrder: 12,
    },
    {
        id: 'totalUnits',
        name: 'Load Details',
        visible: true,
        displayOrder: 13,
    },
    {
        id: 'totalWeight',
        name: 'Total Weight',
        visible: true,
        displayOrder: 14,
    },
    {
        id: 'action',
        name: '',
        visible: true,
        displayOrder: 15,
    },
];

// Map column aliases to their respective CSS classes.
// Fluid sizing mirrors wal-frontend-v2's QuotingDashboard: text columns use `max-w-px min-w-[Npx]`
// so they truncate but stretch, fixed-content columns use `max-w-[6.95%] min-w-[Npx]` so the table
// fills the viewport instead of freezing at pixel widths.
export const COLUMN_CLASSNAME_MAP: Record<string, string> = {
    code: 'max-w-px min-w-[190px]',
    userData: 'max-w-px min-w-[155px]',
    status: 'max-w-[6.95%] min-w-[125px]',
    classification: 'max-w-[6.95%] min-w-[115px]',
    division: 'max-w-px min-w-[150px]',
    customerBillingAccount: 'max-w-[6.95%] min-w-[125px]',
    shipperFullAddress: 'max-w-px min-w-[150px]',
    consigneeFullAddress: 'max-w-px min-w-[150px]',
    stopsCount: 'max-w-[6.95%] min-w-[110px]',
    updatedAt: 'max-w-[6.95%] min-w-[145px]',
    createdAt: 'max-w-[6.95%] min-w-[175px]',
    pickupDate: 'max-w-[6.95%] min-w-[175px]',
    totalWeight: 'max-w-[6.95%] min-w-[135px]',
    totalUnits: 'max-w-px min-w-[135px]',
    // Width is applied dynamically via getActionColumnWidthClass — the column hugs the busiest row.
    action: 'sticky right-0 bg-inherit [&>div]:ml-auto',
};

// Map column aliases to their translation keys
export const COLUMN_TRANSLATION_MAP: Record<string, string> = {
    code: 'Common.Quote',
    userData: 'Common.Created_By',
    status: 'Common.Status',
    classification: 'Common.Service_Type',
    division: 'Common.Division',
    customerBillingAccount: 'Common.Billing_Account',
    shipperFullAddress: 'Common.From',
    consigneeFullAddress: 'Common.To',
    stopsCount: 'MyQuote.Quote_Type',
    updatedAt: 'Common.Last_Modified',
    createdAt: 'Common.Creation_Date',
    pickupDate: 'Common.Pickup_Date',
    totalWeight: 'Common.Total_Weight',
    totalUnits: 'Common.Load_Details',
    action: '',
};

// Customer-portal "Update Pickup Date" flow (past-date quick action on the quote list + past-date
// alert/modal on the quote detail metadata card) is intentionally disabled for CP users — the
// pickup date is managed by WAL staff. Flip to true to re-enable; DatePickupModel and its wiring
// are kept in place.
export const IS_CP_PICKUP_DATE_UPDATE_ENABLED = false;
